/* import __COLOCATED_TEMPLATE__ from './gravatar-image.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import md5 from 'blueimp-md5';

export default Component.extend({
  tagName: 'img',
  attributeBindings: ['src', 'alt', 'title', 'size:height', 'size:width'],
  classNames: ['gravatar-image'],
  size: 250,
  email: '',
  title: '',
  defaultImage: '',
  secure: true,
  retina: false,
  hash: null,

  src: computed(
    'default',
    'defaultImage',
    'email',
    'hash',
    'imageSize',
    'secure',
    function () {
      var email = this.email || '';
      var imageSize = this.imageSize;
      var def = this.defaultImage;
      var secure = this.secure;
      var protocol = secure ? 'https' : 'http';

      var hashToUse = this.hash || md5(email);
      return (
        protocol +
        '://www.gravatar.com/avatar/' +
        hashToUse +
        '?s=' +
        imageSize +
        '&d=' +
        def
      );
    },
  ),

  imageSize: computed('size', 'retina', function () {
    var size = this.size;
    return this.retina ? size * 2 : size;
  }),
});
